import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './ticket_log_card.scss';
import Cleave from 'cleave.js';

application.register(
  'ticket-log-card',
  class extends Controller {
    static targets = ['number', 'expirationInput', 'expiration'];

    connect() {
      new Cleave('#card-number', { blocks: [4, 4, 4, 4], numericOnly: true });
      new Cleave('#cvv', { blocks: [3], numericOnly: true });
    }

    updateCardNumber(event) {
      const inputText = event.target.value;
      const cardText = inputText.length > 0 ? inputText : '•••• •••• •••• ••••';
      this.numberTarget.innerHTML = cardText;
    }

    updateCardExpiration(event) {
      const month = this.expirationInputTargets[0].value;
      const year = this.expirationInputTargets[1].value;
      this.expirationTarget.innerHTML = `Val ${month}.${year}`;
    }
  }
);
